import SectionHeaderText from './SectionHeaderText';

export default SectionHeaderText;
